import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderModule } from './header/header.module';
import { HeroModule } from './hero/hero.module';
import { AboutModule } from './about/about.module';
import { SkillsModule } from './skills/skills.module';
import { ResumeModule } from './resume/resume.module';
import { PortfolioModule } from './portfolio/portfolio.module';
import { ContactModule } from './contact/contact.module';
import { FooterModule } from './footer/footer.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HeaderModule,
    HeroModule,
    AboutModule,
    SkillsModule,
    ResumeModule,
    PortfolioModule,
    ContactModule,
    FooterModule,
  ],
  exports: [
    HeaderModule,
    HeroModule,
    AboutModule,
    SkillsModule,
    ResumeModule,
    PortfolioModule,
    ContactModule,
    FooterModule,
  ],
})
export class ComponentsModule {}
